module.exports = __webpack_public_path__ + "img/optimization_quotes.24f9f396.png";